<template>
  <div>
   <v-app-bar  app    
      color="appMenu"
      dense
      class="fill-height"
      dark
        height="32"
      fixed> 
      <v-icon left > mdi-history</v-icon>{{$t('menu.activitylogs')}}
        <v-spacer></v-spacer>
  </v-app-bar>
 <v-container fluid>
      <v-row justify="center">
        <v-col cols="12">
            <Activities />      
        </v-col>
      </v-row>         
 
 </v-container>
  </div>
</template>
<style scoped>
::v-deep .container--fluid {
  padding:0px !important;
}
</style>
<script>
// @ is an alias to /src
import Activities from '@/components/admin/Activities.vue'

export default {
  name: 'ActivityLogs',
  components: {
    Activities
  }
}
</script>
